import {NgModule} from '@angular/core';
import {IonicModule, NavParams} from '@ionic/angular';
import {CommonModule} from '@angular/common';
import {Keyboard} from '@awesome-cordova-plugins/keyboard/ngx';
import {ComponentsModule} from '../../components/components.module';
import {CreateAppPage} from './create-app';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    ComponentsModule,
  ],
  declarations: [CreateAppPage],
  providers: [
    NavParams,
    Keyboard,
  ],
})
export class CreateAppPageModule {}
